import axios from 'utils/axios';
import { AppointmentsType } from 'types';

export const setAppointmentsStatus = (appointmentId: string, status: AppointmentsType) => {
  return axios.put(`/api/v1/appointments/${appointmentId}/status`, {
    status: status
  });
};
